<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-apps
      </v-icon> Product Categories
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createProductCategory()"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="productCategories"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              {{ item.product_tier | productUpdate }}
            </td>
            <td>
              <font
                :color="getColor(item.active)"
                class="font-my-style"
              >
                {{ item.active | statusUpdate }}
              </font>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="productCategoryPrices(item.id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <create-product-category
      v-if="showForm"
      @closed="showForm=false"
      @get-product-category-list="getProductCategoryList()"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreateProductCategory from './CreateProductCategory.vue';

  export default {
    name: 'ProductCategories',
    components: {
      'centre-spinner': spinner,
      'create-product-category': CreateProductCategory,
    },
    filters: {
      statusUpdate (active) {
        if (active === true) {
          return 'Active*';
        } else {
          return 'InActive';
        }
      },
      productUpdate (product) {
        if (product === 'advanced') {
          return 'Advanced';
        } else if (product === 'basic') {
          return 'Basic';
        } else {
          return 'Enterprise';
        }
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Discription', value: 'description' },
          { text: 'Product Tier', value: 'product_tier' },
          { text: 'Status', value: 'status' },
          { text: 'Prices', value: 'prices' },
        ],
        showForm: false,
      };
    },
    computed: {
      productCategories () {
        return this.$store.getters['payments/getProductCategoryList'];
      },
    },
    async mounted () {
      await this.getProductCategoryList();
    },
    methods: {
      async getProductCategoryList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchProductCategoryList');
        this.loading = false;
      },
      getColor (status) {
        if (status === true) {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      productCategoryPrices (productcategoryid) {
        this.$router.push(`product-category/${productcategoryid}/prices`);
      },
      createProductCategory () {
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
</style>
